import PropTypes from 'prop-types'
import classNames from 'classnames'
import React, { Component, Fragment } from 'react'
import { X } from '@everlane/icon'

import SlideLeftRight from 'base/react/animations/slide_left_right'
import SlideUpDown from 'base/react/animations/slide_up_down'

export default class Dropdown extends Component {
  static propTypes = {
    children: PropTypes.element,
    onRequestClose: PropTypes.func,
    fullScreen: PropTypes.bool,
    scrollable: PropTypes.bool,
    appear: PropTypes.bool,
    topOffset: PropTypes.number,
    headerHeight: PropTypes.number,
    className: PropTypes.string,
    overlayClassName: PropTypes.string,
    animation: PropTypes.oneOf(['horizontal', 'vertical']),
    includeOverlay: PropTypes.bool,
    showCloseButton: PropTypes.bool,
  }

  static defaultProps = {
    fullScreen: false,
    scrollable: false,
    appear: false,
    topOffset: 0,
    headerHeight: 40,
    animation: 'horizontal',
    includeOverlay: false,
  }

  handleRequestClose = () => {
    this.props.onRequestClose()
  }

  render() {
    const {
      children,
      className,
      overlayClassName,
      fullScreen,
      scrollable,
      topOffset,
      headerHeight,
      animation,
      includeOverlay,
      showCloseButton,
    } = this.props

    const content = (() => {
      if (!children) {
        return null
      }
      const dropdownClass = classNames('dropdown', className, {
        'dropdown--full-screen': fullScreen,
        'dropdown--scrollable': scrollable,
        'dropdown--modal': includeOverlay,
      })

      const marginTop = fullScreen ? 0 : topOffset + headerHeight

      return (
        <div className={dropdownClass} style={{ marginTop }}>
          {showCloseButton && <X className="dropdown-x" onClick={this.handleRequestClose} />}
          {children}
        </div>
      )
    })()

    const AnimationComponent = animation === 'vertical' ? SlideUpDown : SlideLeftRight

    return (
      <Fragment>
        {includeOverlay && (
          <div
            className={classNames('overlay', overlayClassName)}
            onClick={this.handleRequestClose}
          />
        )}
        <AnimationComponent appear={this.props.appear}>{content}</AnimationComponent>
      </Fragment>
    )
  }
}
